import type { HTMLAttributes } from 'react';

import { cn } from 'src/utils/classNamesHelper';

// TODO: Circle variant
export const Skeleton = ({
  children,
  className = '',
  isLoading = true,
  ...rest
}: HTMLAttributes<HTMLDivElement> & {
  isLoading?: boolean;
}) => {
  return (
    <div
      data-cy="skeleton"
      className={cn(
        'rounded-sm !w-fit transition-all duration-300',
        {
          'animate-pulse bg-neutral-light-8 [&>*]:invisible [&>*]:opacity-0':
            isLoading,
        },
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
